import {
  Agreement,
  ApplicationProductTypeEnum,
  Mutation,
  Query,
} from '@varo/graphql-schema-types';
import { submitChargeCardApplicationMutation } from 'services/graphql/mutations/StartBelieveApplication';
import FetchUser from 'services/graphql/queries/FetchUser';
import GetAgreements from 'services/graphql/queries/GetAgreements';
import { AnyVariables, useMutation, useQuery } from 'urql';

const useBelieveApplication = () => {
  const [{ data: userData, fetching: userFetching, error: userFetchingError }] =
    useQuery<Query, AnyVariables>({
      query: FetchUser,
      requestPolicy: 'cache-and-network',
    });

  const userDataAvailable = userData && !userFetching && !userFetchingError;

  const userFullName = userDataAvailable
    ? `${userData.user?.customerInfo?.name?.first} ${userData.user?.customerInfo?.name?.last}`
    : '';
  const userEmail = userDataAvailable
    ? `${userData.user?.customerInfo?.email.address}`
    : '';
  const userAddressLine1 = userDataAvailable
    ? `${userData.user?.customerInfo?.address?.addressLine1}`
    : '';
  const userAddressLine2: string | null =
    userDataAvailable && userData.user?.customerInfo?.address?.addressLine2
      ? `${userData.user?.customerInfo?.address?.addressLine2}`
      : '';
  const userCityStateZip = userDataAvailable
    ? `${userData.user?.customerInfo?.address?.city}, ${userData.user?.customerInfo?.address?.state} ${userData.user?.customerInfo?.address?.zip}`
    : '';
  const userPhone = userDataAvailable
    ? `${userData.user?.customerInfo?.phone}`
    : '';

  const [
    {
      data: agreementsData,
      fetching: agreementsFetching,
      error: agreementsError,
    },
  ] = useQuery<Query, { types: ApplicationProductTypeEnum[] }>({
    variables: {
      types: [ApplicationProductTypeEnum.ChargeCard],
    },
    query: GetAgreements,
    requestPolicy: 'cache-and-network',
  });

  const agreementsDataAvailable =
    agreementsData && !agreementsFetching && !agreementsError;

  const agreements: Agreement[] = agreementsDataAvailable
    ? agreementsData.agreements
    : [];
  const agreementIdList: string[] = agreementsDataAvailable
    ? agreements.flatMap((agreement) => agreement.id)
    : [];

  const [mutationResult, submitChargeCardApplication] = useMutation<Mutation>(
    submitChargeCardApplicationMutation,
  );

  const {
    fetching: mutationFetching,
    data: mutationData,
    error: mutationError,
  } = mutationResult;

  const fetching = userFetching || agreementsFetching;
  const error = userFetchingError || agreementsError;

  return {
    agreements,
    userFullName,
    userEmail,
    userPhone,
    userAddressLine1,
    userAddressLine2,
    userCityStateZip,
    fetching,
    mutationFetching,
    mutationData,
    mutationError,
    agreementIdList,
    submitChargeCardApplication,
    error,
  };
};

export default useBelieveApplication;
